import { cloneDeep } from 'lodash';

import { ScreenPreference, SubtitlePreference } from '@/types/components';
import { getScreenPreference, getSubtitlePreference } from '@/utils/constants/chatPreference';

export const useChatPreferenceStore = defineStore(
  'chatPreference',
  () => {
    const screenPreference = ref<ScreenPreference>(cloneDeep(getScreenPreference()));
    const subtitlePreference = ref<SubtitlePreference>(cloneDeep(getSubtitlePreference()));

    const updateScreenPreference = (newVal: Partial<ScreenPreference>) => {
      screenPreference.value = { ...screenPreference.value, ...newVal };
    };
    const updateSubtitlePreference = (newVal: Partial<SubtitlePreference>) => {
      subtitlePreference.value = { ...subtitlePreference.value, ...newVal };
    };

    return { screenPreference, subtitlePreference, updateScreenPreference, updateSubtitlePreference };
  },
  { persist: { storage: sessionStorage } }
);

export const useChatRemotePreferenceStore = defineStore(
  'chatRemotePreference',
  () => {
    const screenRemotePreference = ref<ScreenPreference>(cloneDeep(getScreenPreference()));
    const subtitleRemotePreference = ref<SubtitlePreference>(cloneDeep(getSubtitlePreference()));

    const updateScreenRemotePreference = (newVal: Partial<ScreenPreference>) => {
      screenRemotePreference.value = { ...screenRemotePreference.value, ...newVal };
    };
    const updateSubtitleRemotePreference = (newVal: Partial<SubtitlePreference>) => {
      subtitleRemotePreference.value = { ...subtitleRemotePreference.value, ...newVal };
    };

    return {
      screenRemotePreference,
      subtitleRemotePreference,
      updateScreenRemotePreference,
      updateSubtitleRemotePreference,
    };
  },
  { persist: { storage: localStorage } }
);
